import mergeWith from 'lodash.mergewith';

export function yesNoDefaultValue(bool) {
  return bool === true ? 'yes' : bool === false ? 'no' : '';
}

const replaceArrays = (objValue, srcValue) => {
  if (Array.isArray(objValue) && Array.isArray(srcValue)) {
    return srcValue;
  }
};

export function deepMerge(base, patch) {
  return mergeWith({}, base, patch, replaceArrays);
}
